export default __webpack_public_path__ + "static/Linh_Han2-7a04deecf455cc533a8ca4d089703df7.png";